import { useMemo, useCallback } from "react";
import classnames from "classnames";
import DropdownSelect from "@/components/DropdownSelect";
import { useMatchMedia } from "@/hooks";
import dayjs from "@/lib/day";
import styles from "@/styles/DateTab.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DateTab(_ref) {
  let {
    selectedDay,
    onClick
  } = _ref;
  const mobileSize = useMatchMedia([{
    query: "screen and (max-width: 520px)",
    value: true
  }], false);
  const days = useMemo(() => {
    const now = dayjs();
    const range = [...Array(8)].map((_, k) => k);
    return range.map(i => {
      const day = now.add(i, "day");
      return {
        text: i == 0 ? "本日" : day.format("M/D(dd)"),
        value: day.format("YYYY-MM-DD")
      };
    });
  }, []);
  const handleClick = useCallback(day => {
    return () => {
      if (onClick) {
        onClick(day);
      }
    };
  }, []);
  const handleSelect = useCallback(_ref2 => {
    let {
      value
    } = _ref2;
    if (onClick) {
      onClick(value);
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [!mobileSize && /*#__PURE__*/_jsx(_Fragment, {
        children: days.map(day => /*#__PURE__*/_jsx("div", {
          className: classnames(styles.tab, {
            [styles.active]: day.value === selectedDay
          }),
          onClick: handleClick(day.value),
          children: day.text
        }, day.value))
      }), mobileSize && /*#__PURE__*/_jsx(DropdownSelect, {
        className: styles.dropdown,
        options: days,
        onSelect: handleSelect
      })]
    })
  });
}